export default function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1024px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">
            APP下载
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            下载51吃瓜视频APP，随时随地畅享最新吃瓜内容
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-8">
            <div className="flex flex-col md:flex-row items-center gap-6 md:gap-10">
              <div className="w-40 h-40 md:w-48 md:h-48 rounded-2xl bg-background-50 border border-background-200/70 flex items-center justify-center flex-shrink-0">
                <div className="text-center">
                  <div className="w-16 h-16 flex items-center justify-center rounded-2xl bg-primary-500 text-background-50 font-bold text-2xl mx-auto mb-2">
                    51
                  </div>
                  <span className="font-heading text-sm text-foreground-700">51吃瓜视频</span>
                </div>
              </div>
              <div className="flex-1 text-center md:text-left">
                <h3 className="font-heading text-lg text-foreground-900 mb-3">
                  随时随地，畅快吃瓜
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed mb-5">
                  51吃瓜视频APP支持iOS和Android双平台，安装后即可享受更流畅的浏览体验。支持消息推送，第一时间获取热门爆料通知，让您不错过任何精彩内容。51吃瓜官网全网最新入口在APP端同样保持高速稳定访问。
                </p>
                <div className="flex flex-wrap items-center gap-3 justify-center md:justify-start">
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap">
                    <i className="ri-apple-line"></i>
                    iOS 下载
                  </div>
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-foreground-900 text-background-50 rounded-lg text-sm font-medium cursor-pointer hover:bg-foreground-800 transition-colors whitespace-nowrap">
                    <i className="ri-android-line"></i>
                    Android 下载
                  </div>
                  <div className="inline-flex items-center gap-2 px-4 py-2 bg-background-50 border border-background-200 text-foreground-700 rounded-lg text-sm font-medium cursor-pointer hover:bg-background-200 transition-colors whitespace-nowrap">
                    <i className="ri-qr-code-line"></i>
                    扫码下载
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}